import { useEffect, useState } from "react";
import apiService from '../../services/apiService';
// import '../../styles/pages/dataSets.scss';
import Add from "../../assets/icons/add"

export default function UserManagement() {
    // const [dataSetList, setdataSetList] = useState([]);
    // const [publicDataList, setPublicDataList] = useState([]);
    // const [privateDataList, setPrivateDataList] = useState([]);
    const [modal, setModal] = useState(false);
    const [error, setError] = useState("")

    // const getDataDetail = async (data, dataList) => {
    //     await apiService.GetDataDetails(data.id).then((res) => {
    //         const i = dataList.findIndex(x => x.id == data.id)
    //         let replacingData = { ...dataList[i], ...res.data }
    //         dataList[i] = replacingData
    //         setdataSetList(dataList);
    //     }).catch(() => {
    //         const i = dataList.findIndex(x => x.id == data.id)
    //         let replacingData = { ...dataList[i] }
    //         dataList[i] = replacingData
    //         setdataSetList(dataList);
    //     })
    // }

    // const getDataSet = async () => {
    //     await apiService.GetDatasets().then((response) => {
    //         let dataList = response?.data
    //         dataList?.length > 0 && dataList?.map((data) =>
    //             getDataDetail(data, dataList)
    //         )
    //     }).catch((err) => {
    //         setError(err.response.status)
    //     })
    // };

    // useEffect(() => {
    //     let publicList = []
    //     let privateList = []
    //     dataSetList?.length > 0 && dataSetList?.map((data) => {
    //         if (data?.is_public == true) {
    //             publicList.push(data)
    //         }
    //         else {
    //             privateList.push(data)
    //         }
    //     })
    //     setPublicDataList(publicList)
    //     setPrivateDataList(privateList)
    // }, [dataSetList]);

    // useEffect(() => {
    //     getDataSet();
    // }, []);

    return (
        <div className="datasets-main">
            <div className="d-flex justify-content-between">
                <div style={{ fontWeight: "500", fontSize: "16px" }}> User Management</div>
                <div>
                    <input type="text" className="search" name="search" placeholder="Search" style={{ padding: "5px" }} />
                </div>
                <button className="newdata" onClick={() => setModal(true)} data-bs-toggle="modal" data-bs-target="#myModal">
                    <Add color={"#f58220"} />
                    <a style={{ paddingLeft: "0.5rem" }}>New User</a>
                </button>
            </div>
            <br />

        </div>
    );
}